module.exports = __webpack_public_path__ + "static/media/Equal-Play-Thesis-GER.0d0c5e76.pdf";